import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaTrash, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, getCurrentUser} from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';
import AsyncSelect from 'react-select/async';
import { IMaskInput } from "react-imask";

class ExamesStatus extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaExamesStatus = this.buscaExamesStatus.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            page_numb: 1,
            loading: true,
            nome: "",
            slug: "",
            area: "",
            tipo: "",
            programa_id: "",
            programa_nome: "",
        };
    }

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : '';

        this.setState({
            filtro_programa_id: programa_id
        }, () => {
            this.consultaExamesStatus()
        });

    }

    consultaExamesStatus(page_numb = 1) {
        let dados_usuario = getCurrentUser();
        
        this.setState({ loading: true });

        let filtros = `?page=${page_numb}`;

        /*
        if (dados_usuario['ambiente_programa_id']) {
            filtros += `&programa_id=${dados_usuario['ambiente_programa_id']}`;
        } else if(this.state.programa_id){
            filtros += '&programa_id='+this.state.programa_id
        }*/

        if (this.state.nome) {
            filtros += '&nome=' + this.state.nome;
        }

        if (this.state.area) {
            filtros += '&area=' + this.state.area;
        }
        
        if (this.state.tipo) {
            filtros += '&tipo=' + this.state.tipo;
        }

        api.get('/exames/status_motivos/' + filtros)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    page_numb
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar Exames Status, tente novamente.';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });
    }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nome}</td>
                <td>{item.slug}</td>
                <td>{item.tipo}</td>
                <td>{item.area}</td>
                <td className="text-end">
                    <Button variant="light" href={"/status-exames/edit/" + item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button> 
                    <Button className="ms-3" variant="danger" size="sm" onClick={() => this.handleDelete(item.id)}>
                        <FaTrash/>
                    </Button>   
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={3}>Nenhum Exame Status encontrado</td>
            </tr>
        );
    };

    handleDelete = (id) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: "Essa ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/exames/status_motivos/${id}`)
                .then(response => {
                    Swal.fire(
                        'Excluído!',
                        'Exame Status foi excluído com sucesso.',
                        'success'
                    );
                    this.consultaExamesStatus(this.state.busca, this.state.page_numb);
                })
                .catch(error => {
                    Swal.fire(
                        'Erro!',
                        'Ocorreu um problema ao excluir Exame status.',
                        'error'
                    );
                });
            }
        });
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaExamesStatus(num_page)
    };

    buscaExamesStatus(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaExamesStatus(1)
    };

    limpaFiltro = () => {
        this.setState({
            nome: '',
            area: '',
            tipo: '',
            programa_id: '',
        }, () => {
            this.consultaExamesStatus(1);
        })  
    }

    carregaProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                programa_id: event.value, 
                programa_nome: event.label, 
            }));
        } 
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    render() {
        if (!hasPerm('view_exames_status')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Exames Status</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/status-exames/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Exame Status
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaExamesStatus}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="nome"
                                                                value={this.state.nome}
                                                                onChange={this.handleChange}
                                                                placeholder="Nome"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Área</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="area"
                                                                value={this.state.area}
                                                                onChange={this.handleChange}
                                                                placeholder="Área"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Tipo</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="tipo"
                                                                value={this.state.tipo}
                                                                onChange={this.handleChange}
                                                                placeholder="Tipo"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>

                                                <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Slug</th>
                                    <th>Tipo</th>
                                    <th>Área</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={3}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={3}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(ExamesStatus);
